import React from 'react';

const unCheck = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.33333 5.33329H12.6667M3.33333 5.33329C2.59695 5.33329 2 4.73634 2 3.99996C2 3.26358 2.59695 2.66663 3.33333 2.66663H12.6667C13.403 2.66663 14 3.26358 14 3.99996C14 4.73634 13.403 5.33329 12.6667 5.33329M3.33333 5.33329L3.33333 12C3.33333 12.7363 3.93029 13.3333 4.66667 13.3333H11.3333C12.0697 13.3333 12.6667 12.7363 12.6667 12V5.33329M6.66667 7.99996H9.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default unCheck;
